/** Today as YYYY-MM-DD for `<input type="date" max="…">` and MUI TextField inputProps. */
export function getTodayIsoDate() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function getReportDateInputProps() {
  return { max: getTodayIsoDate() };
}

/** Prevent future dates when typed or pasted into date inputs. */
export function clampIsoDateToToday(value) {
  if (!value) return value;
  const max = getTodayIsoDate();
  return value > max ? max : value;
}

/** Load From / Load To: Load To is required when Load From is set, and must be greater. */
export function getReportLoadRangeError(loadFrom, loadTo) {
  const fromRaw = String(loadFrom ?? "").trim();
  const toRaw = String(loadTo ?? "").trim();
  if (!fromRaw) return "";
  if (!toRaw) return "Please enter Load To.";
  const fromNum = Number(fromRaw);
  const toNum = Number(toRaw);
  if (!Number.isFinite(fromNum) || !Number.isFinite(toNum)) {
    return "Please enter valid load values.";
  }
  if (toNum <= fromNum) {
    return "Load To must be greater than Load From.";
  }
  return "";
}
